import Swiper from 'swiper';

(function($, window) {


  let _slice = [].slice;
  let _toString = {}.toString;

  let PageHero = (function() {

    function PageHero() {
      this._init.apply(this, arguments);
    }

    PageHero.dataName = 'PageHero';
    PageHero.defaultOptions = {

    };

    PageHero.prototype = {
      constructor: PageHero,

      _init: function($element, options) {
        this.$element = $element;
        this.$tagline = $element.find('.js-pageHero__tagline');
        this.$slides = $element.find('.js-pageHero__slides');
        this._options = options;
        this._slidesSwiper = null;

        this._setup();
      },

      _setup: function() {

        if(!this._slidesSwiper) {
          this._slidesSwiper = new Swiper(this.$slides[0], {
            autoplay: 4500,
            speed: 1000,
            effect: 'fade',
            fade: {
              crossFade: true
            },
            loop: true
          });
        }

        this._setEvents();
      },

      _setEvents: function() {

      },

      _removeEvents: function() {

      },

      showTagline: function() {
        this.$tagline.addClass('is-shown');
      },

      destroy: function() {
        this._removeEvents();

        this.$element.removeData(PageHero.dataName);
      }

    };

    return PageHero;
  })();

  let methods = {

    init: function(options) {
      options = $.extend(true, {}, PageHero.defaultOptions, options);

      this.each(function() {
        let $element = $(this);
        $element.data(PageHero.dataName, new PageHero($element, options));
      });
    },

    showTagline: function() {

      this.each(function() {
        let instance = $(this).data(PageHero.dataName);

        if(!instance) {
          return;
        }

        instance.showTagline();
      });
    },

    destroy: function() {

      this.each(function() {
        let instance = $(this).data(PageHero.dataName);

        if(!instance) {
          return;
        }

        instance.destroy();
      });
    }
  };


  $.fn.pageHero = function() {

    let args = _slice.call(arguments);

    let first = args[0];

    let rest = args.length > 1 ? _slice.call(arguments, 1) : [];

    if (!first) {
        methods.init.call(this);
    }

    else if($.isPlainObject(first)) {
        methods.init.apply(this, args);
    }

    else if(_toString.call(first) === '[object String]' && (first in methods)) {
        methods[first].apply(this, rest);
    }

    else {
        $.error('Failed to invoke a method or to initialise plugin.');
    }

    return this;
  };

})(jQuery, window);



// WEBPACK FOOTER //
// ./src/js/jquery-plugin/pageHero.js